import { render, staticRenderFns } from "./GameLevel.vue?vue&type=template&id=45ff398b&"
import script from "./GameLevel.vue?vue&type=script&lang=js&"
export * from "./GameLevel.vue?vue&type=script&lang=js&"
import style0 from "./GameLevel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports